import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPromoCodes from "@/pages/admin/AdminPromoCodes";

export const Route = createFileRoute("/admin/promo-codes")({
  head: () => pageHead("Admin \u2014 Promo Codes \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPromoCodes,
});
